import { render, staticRenderFns } from "./Nbc.vue?vue&type=template&id=318fa363&scoped=true"
import script from "./Nbc.vue?vue&type=script&lang=js"
export * from "./Nbc.vue?vue&type=script&lang=js"
import style0 from "./Nbc.vue?vue&type=style&index=0&id=318fa363&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fa363",
  null
  
)

export default component.exports